import { VenueForm } from "components/venues";

export const CreateVenue = () => {
  return <VenueForm isNew />;
};
